import { UPLOAD_PDFS } from '../actions/types';

const initialState = null;

export default function(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_PDFS:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/uploadReducer.js